// Lightweight Meta Pixel integration
// Provides init + simple tracking helpers that safely no-op if Pixel is blocked/missing

declare global {
  interface Window {
    fbq?: (...args: any[]) => void;
  }
}

function ensureFacebookPixelLoaded(pixelId: string): void {
  if (typeof window === "undefined") return;
  if (window.fbq) return;

  // Create fbq shim
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  window.fbq = function () {
    // eslint-disable-next-line prefer-rest-params
    (window.fbq as any).callMethod
      ? (window.fbq as any).callMethod.apply(window.fbq, arguments)
      : (window.fbq as any).queue.push(arguments);
  } as any;
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  (window.fbq as any).queue = [];
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  (window.fbq as any).loaded = false;
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  (window.fbq as any).version = "2.0";

  const script = document.createElement("script");
  script.async = true;
  script.src = "https://connect.facebook.net/en_US/fbevents.js";
  const firstScript = document.getElementsByTagName("script")[0];
  firstScript?.parentNode?.insertBefore(script, firstScript);

  window.fbq && window.fbq("init", pixelId);
}

export function initFacebookPixel(pixelId: string | undefined): void {
  if (!pixelId) return;
  try {
    ensureFacebookPixelLoaded(pixelId);
  } catch (_err) {
    // swallow; do not break app
  }
}

export function trackPageView(): void {
  try {
    window.fbq && window.fbq("track", "PageView");
  } catch (_err) {
    // ignore
  }
}

export function trackEvent(eventName: string, params?: Record<string, unknown>): void {
  try {
    if (window.fbq) {
      params ? window.fbq("track", eventName, params) : window.fbq("track", eventName);
    }
  } catch (_err) {
    // ignore
  }
}



